import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ChevronDownIcon } from "lucide-react";
import { cn } from "../lib/cn.js";
import { fieldClass } from "./input.js";
/**
 * A native select (works with React Hook Form's `register`, keyboard and phone pickers without extra code), drawn
 * like the other fields with its own chevron. `className` sizes the control (width, height).
 */
export function Select({ className, ...props }) {
    return (_jsxs("span", { className: cn("relative inline-flex w-full min-w-0", className), children: [_jsx("select", { className: cn(fieldClass, "cursor-pointer appearance-none pr-9", "[&>option]:bg-card"), ...props }), _jsx(ChevronDownIcon, { className: "pointer-events-none absolute top-1/2 right-3 size-4 -translate-y-1/2 text-muted-foreground", "aria-hidden": true })] }));
}
//# sourceMappingURL=select.js.map